import { IconX } from "@tabler/icons";
import { Avatar, Text } from "@mantine/core";
import { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import { isMobile } from "react-device-detect";
import { Fragment } from "react";
import { useColors } from "../../../../../hooks/colors/useColors";
import { useRedirectAnonymous } from "../../../../../hooks/auth/useRedirectAnonymous";
import { useUser } from "../../../../../hooks/react-query/useUser";
import { MyHead } from "../../../../../components/pages/MyHead";
import { Container } from "../../../../../components/UI/container/Container";
import { MyH1 } from "../../../../../components/UI/my-h1/MyH1";
import { MyButton } from "../../../../../components/UI/my-button/MyButton";
import { use } from "i18next";
import {
  queryClient,
  QueryKeys,
} from "../../../../../hooks/react-query/query-client";
import { Footer } from "../../../../../components/pages/homepage/footer/Footer";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function CancelPaymentPage() {
  const { colors } = useColors();
  const redirect = useRedirectAnonymous();
  const router = useRouter();
  const { user, userIsLoading } = useUser();
  const { i18n } = useTranslation("common");

  async function goBack() {
    await queryClient.invalidateQueries(QueryKeys.APPOINTMENTS);
    await router.push("/user");
  }

  return (
    <Fragment>
      <MyHead
        title={i18n.t("payment.cancel-message")}
        description={i18n.t("payment.cancel-message")}
      />
      {user && !userIsLoading && (
        <Container noHeight>
          <div
            style={{ minHeight: "calc(100vh - 300px)" }}
            className="flex flex-col justify-center items-center gap-4"
          >
            <Avatar
              styles={{ placeholder: { backgroundColor: colors.danger } }}
              radius={150}
              size={300}
            >
              <IconX size={300} color={colors.white} />
            </Avatar>
            <MyH1 size={isMobile ? "2.5rem" : "3rem"} centerText>
              {i18n.t(`payment.cancel-message`)}
            </MyH1>
            <MyButton
              marginTop
              size="xl"
              fontSize="1.5rem"
              height="3rem"
              onClick={goBack}
              title={i18n.t("back")}
              color={colors.secondary}
            />
          </div>
        </Container>
      )}
      <Footer isVisible />
    </Fragment>
  );
}

export default CancelPaymentPage;
